// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"db4ff204","453":"32beca69"}[chunkId] + ".chunk.js";
};